module.exports = __webpack_public_path__ + "img/greenncap.507146c1.png";